import {
    createHandlerChainRunner
} from "@insite/client-framework/HandlerCreator";
import { DocumentSearchParameters } from "@us/Services/DocumentSearch/DocumentSearchService";
import { CustomApiHandler } from "@us/Store/CustomHandlerCreator";
import { DocumentSearchPageParameterModel } from "@us/Store/Data/DocumentSearchPage/DocumentSearchPageState";

type HandlerType = CustomApiHandler<DocumentSearchParameters, DocumentSearchPageParameterModel>;

export const PopulateApiParameter: HandlerType = (props: any) => {
    props.apiParameter = props.parameter;
};

export const SetDocumentSearchPageData: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DocumentSearchData/SetDocumentSearchPage",
        result: props.parameter,
    });
};

export const chain = [PopulateApiParameter, SetDocumentSearchPageData];

const documentSearchPageHandler = createHandlerChainRunner(chain, "DocumentSearchPageHandler");
export default documentSearchPageHandler;